import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { NodeActions } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { isAnswerCorrect } from 'src/app/quiz/config/quiz';
import { SelectAnatomyQuestion } from 'src/app/quiz/models/quiz-question.model';

@Component({
  selector: 'app-view-quiz-select-anatomy-answer',
  templateUrl: './view-quiz-select-anatomy-answer.component.html',
  styleUrls: ['./view-quiz-select-anatomy-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizSelectAnatomyAnswerComponent implements OnInit {
  
  @Input()
  question: SelectAnatomyQuestion;

  @Input()
  answer: string[];

  @Input()
  summary: boolean;

  get isCorrect(): boolean {
    return isAnswerCorrect(this.question, this.answer);
  }

  constructor(private store: Store) { }

  ngOnInit(): void {
  }

  handleSelectedObjectsClick(objectIds: string[]) {
    this.setSelectedObjects(objectIds);
  }

  handleCorrectObjectsClick(objectIds: string[]) {
    this.setSelectedObjects(objectIds);
  }

  private setSelectedObjects(objectIds: string[]) {
    const checkedObjectIds = objectIds
      .filter((objectId) => objectId && objectId !== '');

    // clear selections
    this.store.dispatch(
      new NodeActions.UpdateNodesChecked(false)
    );
    // apply selections
    this.store.dispatch(
      new NodeActions.UpdateNodesChecked(true, checkedObjectIds)
    );
  }

}
